export enum ThreadError {
	THREADS_ERROR = 'There was an error loading threads. Please try again.',
	DELETE_ERROR = 'There was an error deleting the thread. Please try again.',
	CHANGE_STATUS_ERROR = 'There was an error changing the status of the thread. Please try again.',
}

export enum ThreadMessage {
	DELETE_MESSAGE = 'Are you sure you want to delete?',
	CHANGE_STATUS_MESSAGE = 'Are you sure you want to change the status?',
}
